<template>
  <div class="row">
    <header-servico
      tipo="Atendimentos"
      :familia="familia.id"
      :loading="loading"
    />
    <load v-if="loading" message="Carregando Atendimentos da Família" />
    <div v-else class="col-md-12">
      <!--Tabela-->
      <div class="row">
        <sidebar-servicos />
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div
                  v-if="!novo_atendimento && !showImpressoaAtendimentos"
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div>
                          <button
                            class="btn btn-primary"
                            @click="novo_atendimento = true"
                          >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                        </div>
                        <div class="d-flex align-items-center">
                          <b-button-group>
                            <b-button
                              variant="outline-dark"
                              :class="viewFilterReport === true ? 'active' : ''"
                              @click="viewFilters"
                            >
                              <i class="fas fa-filter"></i>
                              {{ $t("Filtros") }}
                            </b-button>
                            <b-button variant="outline-dark" @click="print()">
                              <i class="fas fa-print"></i>
                            </b-button>
                            <b-button
                              variant="outline-dark"
                              @click="exportar()"
                              :title="$t('Exportar')"
                              v-b-tooltip.hover
                            >
                              <i class="fas fa-file-excel"></i>
                            </b-button>
                          </b-button-group>

                          <div>
                            <button class="btn btn-success btn-sm ml-4" @click="gerarImpressao()">
                              Gerar Impressão
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" v-if="viewFilterReport">
                      <form @submit.prevent="getAtendimentos" ref="formFiltros">
                        <div class="row">
                          <form-select
                            v-model="filtroFamiliar"
                            label="Pesquisar Familiar"
                            :itens="familiares"
                            grid="8"
                            :multiple="true"
                          />

                          <form-select
                            v-model="filtroStatus"
                            label="Status"
                            :itens="status"
                            grid="4"
                            :multiple="true"
                          />

                          <form-select
                            v-model="filtroTipos"
                            label="Tipo de Intervenção"
                            :itens="tipoIntervencao"
                            grid="4"
                            :multiple="true"
                          />

                          <form-toggle
                            v-model="filtrarDatas"
                            grid="12"
                            label="Filtrar por Datas?"
                          />

                          <template v-if="filtrarDatas">
                            <form-calendar
                              v-model="data_inicio"
                              grid="6"
                              label="Data inicial realizado"
                              :max-date="dataNow"
                              :required="data_fim ? true : false"
                            />
                            <!-- :required="verificaDataInicial" -->
                            <form-calendar
                              v-model="data_fim"
                              grid="6"
                              label="Data final realizado"
                              :min-date="data_inicio"
                              :max-date="dataNow"
                              :required="data_inicio ? true : false"
                            />

                            <form-calendar
                              v-model="data_inicio_at"
                              grid="6"
                              label="Data inicial cadastro"
                              :max-date="dataNow"
                              :required="data_fim_at ? true : false"
                            />
                            <!-- :required="verificaDataInicialAt" -->
                            <form-calendar
                              v-model="data_fim_at"
                              grid="6"
                              label="Data final cadastro"
                              :min-date="data_inicio_at"
                              :max-date="dataNowAt"
                              :required="data_inicio_at ? true : false"
                            />
                          </template>
                        </div>
                        <div
                          class="row pt-2 mb-4 px-0 d-flex justify-content-end"
                        >
                          <div class="col-auto px-2 text-right">
                            <button
                              class="btn btn-default btn-sm"
                              @click.prevent="
                                limparFiltros();
                                viewFilterReport = false;
                              "
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-secondary btn-sm"
                              @click.prevent="limparFiltros()"
                            >
                              {{ $t("Limpar Filtros") }}
                            </button>
                            <button
                              class="btn btn-success btn-submit btn-sm"
                              data-style="zoom-in"
                              type="submit"
                            >
                              <i class="fas fa-chart-bar"></i>
                              {{ $t("Filtrar") }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <load mode="table" v-if="loadingAtendimentos" />
                    <div class="col-md-12" v-else>
                      <span>
                        <a v-if="!showName" @click.prevent="mostrarNome" href="#"><i class="fas fa-eye"></i> Mostrar Nome de Registro</a>
                        <a v-else @click.prevent="ocultarNome" href="#"><i class="fas fa-eye-slash"></i> Ocultar Nome de Registro</a>
                      </span>
                      <print-content>
                        <b-table
                          :fields="[
                            {
                              key: 'protocolo',
                              label: $t('Detalhes'),
                            },
                            {
                              key: 'created_at',
                              label: $t('Data'),
                            },
                            {
                              key: 'status_nome',
                              label: $t('Status'),
                            },
                            {
                              key: 'actions',
                              label: '',
                              class: 'text-right no-print',
                              thStyle: {
                                width: '95px',
                                minWidth: '95px',
                              },
                            },
                          ]"
                          :items="AtendimentosList"
                          :responsive="true"
                          striped
                          hover
                          show-empty
                          small
                          outlined
                          stacked="xs"
                          table-class="mb-3"
                        >
                          <template v-slot:cell(protocolo)="data">
                            <i
                              class="mdi mdi-lock mdi-18px text-danger"
                              v-if="data.item.privado == 1"
                              v-b-popover.hover.top="'Atendimento com sigilo'"
                            ></i>
                            Usuário(s):<br />
                            <ul>
                              <li
                                v-for="pessoa in data.item.usuarios"
                                :key="pessoa.id"
                              >
                                <b v-if="!pessoa.nome_social" >{{ pessoa.nome_completo }}</b>
                                <b v-else>
                                  {{ pessoa.nome_social }}
                                  ( N.R.: )
                                  <span v-if="showName">{{ pessoa.nome_completo }}</span>
                                </b>
                              </li>
                            </ul>
                            Protocolo: <b>{{ data.item.protocolo }}</b>
                            <br />
                            Tipo: <b>{{ data.item.tipo.descricao }}</b>
                            <br />
                            Unidade:
                            <b>{{
                              data.item.unidade ? data.item.unidade.nome : ""
                            }}</b>
                            <br />
                            Técnico responsável:
                            <b>{{ data.item.tecnico.nome}}</b>
                            <br />
                            Técnico autor:
                            <b>{{ data.item.autor}}</b>
                            <br />
                            <span
                              class="d-block"
                              v-if="data.item.outros_tecnicos.length > 0"
                            >
                              <b-link @click="showTecnicos = !showTecnicos">
                                <span v-if="!showTecnicos"
                                  >Mostrar Técnicos participantes ({{
                                    data.item.outros_tecnicos.length
                                  }})</span
                                ><span v-else
                                  >Esconder Técnicos participantes</span
                                >
                              </b-link>
                            </span>
                            <span v-if="showTecnicos">
                              <small
                                class="d-block text-muted"
                                v-if="data.item.outros_tecnicos.length > 0"
                              >
                                Outros técnicos
                                <ul>
                                  <li
                                    v-for="tecnico in data.item
                                      .lista_outros_tecnicos"
                                    :key="tecnico.nome"
                                  >
                                    <strong>{{
                                      tecnico.nome | toUpper
                                    }}</strong> - <span> {{ tecnico.profissao ?? 'Não informado' | toUpper }} </span>
                                    <span class="d-block small">{{
                                      tecnico.unidade.nome | toUpper
                                    }}</span>
                                  </li>
                                </ul>
                              </small>
                            </span>
                          </template>
                          <template v-slot:cell(created_at)="data">
                            <span class="d-block small text-small">
                              Realizado: {{ data.item.data_cadastro }}
                            </span>
                            <span class="d-block small text-small">
                              Cadastrado: {{ data.item.created_at }}
                            </span>
                          </template>
                          <template v-slot:cell(status_nome)="data">
                            <span
                              class="small"
                              v-html="data.item.status_nome"
                            ></span>
                          </template>
                          <template v-slot:cell()="data">
                            <button
                              @click="redirectAtendimento(data.item.id)"
                              class="px-2 mb-0 btn btn-sm btn-success"
                              v-if="
                                user_id == data.item.user_id ||
                                data.item.outros_tecnicos.indexOf(tecnico_id) !=
                                  -1
                              "
                            >
                              <i class="mdi mdi-square-edit-outline" />
                            </button>
                            <BotaoVisualizar
                              v-if="data.item.canView"
                              :to="`/dashboard/atendimentos/show/${data.item.id}`"
                            />
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>

                      <div class="row align-items-center no-print">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getAtendimentos"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <NovoAtendimento
                  v-else-if="novo_atendimento && !showImpressoaAtendimentos"
                  :familia="familia"
                  @voltar="novo_atendimento = false"
                />
                <ImpressaoAtendimentos
                  v-else-if="showImpressoaAtendimentos"
                  :familia_id="$route.params.id"
                  :filtroStatus="filtroStatus"
                  :filtroDatas="filtroDatas"
                  :filtroDatasAt="filtroDatasAt"
                  :filtroFamiliar="filtroFamiliar"
                  :filtroTipos="filtroTipos"
                  @voltar="showImpressoaAtendimentos = false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NovoAtendimento from "./Add";
import ImpressaoAtendimentos from "./ImpressaoAtendimentos.vue";
import BotaoVisualizar from "../../../../../resources/js/dashboard/components/widgets/BotaoVisualizar.vue";
export default {
  components: { NovoAtendimento, ImpressaoAtendimentos, BotaoVisualizar },
  name: "Atendimentos",
  metaInfo() {
    return {
      title: this.$i18n.t("Atendimentos"),
    };
  },
  data() {
    return {
      showName: false,
      familia: {},
      novo_atendimento: false,
      tipoIntervencao: [],
      AtendimentosList: [],
      page: 1,
      search: "",
      perPage: 10,
      loadingAtendimentos: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      user_id: null,
      tecnico_id: null,
      unidade_id: null,
      filtroStatus: null,
      filtroDatas: [],
      status: [],
      filtroFamiliar: null,
      familiares: [],
      filtroDatasAt: [],
      dataNowAt: moment().format("YYYY-MM-DD"),
      filtrarDatas: false,
      showTecnicos: false,
      data_fim_at: "",
      data_inicio_at: "",
      data_inicio: "",
      data_fim: "",
      filtroTipos: null,
      showImpressoaAtendimentos: false,
    };
  },
  mounted() {
    this.$route.query.familia_id = this.$route.params.id;
    if (typeof this.$route.query.item === "object") {
      this.familia = this.$route.query.item;
    } else {
      this.getFamilia();
    }
    this.getStatus();
    this.getAtendimentos();
    this.getTipoAtendimentos();
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    filterData(value) {
      return this.$options.filters.formatDateHora(value);
    },
    getAtendimentos() {
      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      this.filtroDatasAt = [];
      if (this.data_inicio_at) {
        this.filtroDatasAt.push(
          this.$options.filters.formatDateYMD(this.data_inicio_at)
        );
      }
      if (this.data_fim_at) {
        this.filtroDatasAt.push(
          this.$options.filters.formatDateYMD(this.data_fim_at)
        );
      }

      this.loadingAtendimentos = true;
      axios
        .get("api/dashboard/atendimentos", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroDatasAt: this.filtroDatasAt,
            filtroFamiliar: this.filtroFamiliar,
            filtroTipos: this.filtroTipos,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.unidade_id = this.$store.state.user.tecnico.unidade_id;
          this.AtendimentosList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getAtendimentos();
          } else {
            this.loadingAtendimentos = false;
          }
        })
        .catch(() => {
          this.loadingAtendimentos = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      this.filtroDatasAt = [];
      if (this.data_inicio_at) {
        this.filtroDatasAt.push(
          this.$options.filters.formatDateYMD(this.data_inicio_at)
        );
      }
      if (this.data_fim_at) {
        this.filtroDatasAt.push(
          this.$options.filters.formatDateYMD(this.data_fim_at)
        );
      }
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/atendimentos", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroDatasAt: this.filtroDatasAt,
            filtroFamiliar: this.filtroFamiliar,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getAtendimentos();
      }
    },
    redirectAtendimento(id) {
      this.$router.push({
        path: `/dashboard/atendimentos/edit/${id}`,
        query: { familia_id: this.$route.query.familia_id },
      });
    },
    getFamilia() {
      axios
        .get("api/dashboard/familias/" + this.$route.params.id)
        .then((response) => {
          this.familia = response.data.data;

          this.familiares = this.familia.familiares.map((elem) => ({
            id: elem.id,
            value: elem.nome_completo,
          }));

          this.$route.query.familia_id = this.familia.id;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
    getStatus() {
      axios.get(`api/dashboard/status/atendimento`).then((response) => {
        this.status = response.data;
      });
    },
    getTipoAtendimentos() {
      axios.get('api/dashboard/report/atendimento/tipos').then((response) => {
        this.tipoIntervencao = response.data;
      });
    },
    limparFiltros() {
      this.search = "";
      this.filtroStatus = null;
      this.filtroDatas = [];
      this.data_inicio = "";
      this.data_fim = "";
      this.data_inicio_at = "";
      this.data_fim_at = "";
      this.filtroFamiliar = [];

      this.filtroDatasAt = [];
      this.filtroTipos = [];

      this.verificaDataInicialAt = false;
      this.getAtendimentos();
    },

    gerarImpressao() {
      this.showImpressoaAtendimentos = true;
    }
  },
};
</script>
